import React from "react";
import SpinnerRound from "./spinnerRound";
export function Spinner() {
    return (<div className="flex justify-center w-full mt-20">
            <SpinnerRound className={"w-12 h-12"} color={"var(--color-brand-600)"}/>
        </div>);
}
//# sourceMappingURL=spinner.jsx.map